import { ValueCardStyled } from '../styles/ValuesStyles';

const ValueCard = ({ value, description, image, index }) => {
  return (
    <ValueCardStyled className={`value-item value-item-${index % 2 === 0 ? 'even' : 'odd'}`}>
      <div className="value-visual">
        <div className="value-image-wrapper">
          <img src={image} alt={value} className="value-image" />
        </div>
      </div>
      <div className="value-content">
        <div className="value-header">
          <h3 className="value-title">{value}</h3>
          <div className="value-accent-line"></div>
        </div>
        <p className="value-description">{description}</p>
      </div>
    </ValueCardStyled>
  );
};

export default ValueCard;
